// utils/clklog.js
import SensorsData from 'sa-sdk-javascript'; // 引入神策 SDK
import sessionEvent  from 'sa-sdk-javascript/dist/web/plugin/session-event/index.es6.js';
import { isRelease } from '../constants';

// 1. 判断当前是否为生产环境
// Vite 项目使用 import.meta.env.PROD
// Webpack/Vue CLI 项目使用 process.env.NODE_ENV === 'production'
const isProd = isRelease; 

class ClkLogService {
  constructor() {
    this.isInit = false;
  }

  /**
   * 初始化方法
   * @param {Object} config - 神策配置项
   */
  init(config) {
    // 2. 只有在生产环境才真正执行初始化
    if (isProd) {
      try {
        SensorsData.init(config);
        SensorsData.use(sessionEvent);
        SensorsData.quick('autoTrack'); //用于采集 $pageview 事件。
        this.isInit = true;
        console.log('✅ ClkLog 生产环境初始化成功');
      } catch (error) {
        console.error('❌ ClkLog 初始化失败:', error);
      }
    } else {
      console.log('ℹ️ 当前为开发环境，ClkLog 已跳过初始化');
    }
  }

  /**
   * 通用埋点方法
   * 如果未初始化，则直接返回，不执行任何操作
   */
  track(eventName, properties) {
    if (isProd && this.isInit) {
      SensorsData.track(eventName, properties);
    }
    // 开发环境下静默，或者你可以选择在这里打印 console.log 方便调试
    // else { console.log(`[Mock Track] ${eventName}`, properties); }
  }

  /**
   * 登录用户 ID 设置
   */
  login(userId) {
    if (isProd && this.isInit) {
      SensorsData.login(userId);
    }
  }

  /**
   * 登出
   */
  logout() {
    if (isProd && this.isInit) {
      SensorsData.logout();
    }
  }
}

// 导出单例
export default new ClkLogService();


// WEBPACK FOOTER //
// ./src/utils/clklog.js